"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLink = createLink;
exports.createQueryParameters = createQueryParameters;
require("core-js/modules/es6.object.keys.js");
require("core-js/modules/es7.object.entries.js");
require("core-js/modules/es6.object.to-string.js");
require("core-js/modules/es6.regexp.to-string.js");
require("core-js/modules/es6.regexp.search.js");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _querystring = _interopRequireDefault(require("querystring"));
function createQueryParameters(_ref) {
  var _window, _window$location;
  var eventProps = _ref.eventProps,
    query = _ref.query;
  var existingProps = _querystring.default.parse(query || '');
  var props = (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, existingProps), eventProps), {}, {
    source_url: typeof window !== 'undefined' ? (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.href : ''
  });

  // Support nested props to 1 level deep
  var keys = Object.keys(props);
  keys.forEach(function (key) {
    if ((0, _isPlainObject2.default)(props[key])) {
      Object.entries(props[key]).forEach(function (_ref2) {
        var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
          subKey = _ref3[0],
          value = _ref3[1];
        props["".concat(key, "_").concat(subKey)] = value;
      });
      delete props[key];
    }
  });

  // Support legacy `pos` prop as a duplicate of productPosition
  if (props.pos == null && props.clickHeader_productPosition) {
    props.pos = props.clickHeader_productPosition;
  }
  var q = _querystring.default.stringify(props);
  return q;
}
function createLink(_ref4) {
  var href = _ref4.href,
    eventProps = _ref4.eventProps;
  try {
    var parsedUrl = new URL(href);
    var result = createQueryParameters({
      eventProps: eventProps,
      query: parsedUrl.searchParams.toString() || ''
    });
    parsedUrl.search = result;
    return parsedUrl.toString();
  } catch (_unused) {
    return '';
  }
}